import Shell from '../assets/shell.jpg';
import Chevron from '../assets/chevron.png'; 
import Exxon from '../assets/exxon.png';
import Total from '../assets/total.png';
import BP from '../assets/bp.png';
import Petrobras from '../assets/petrobras.png';
import Fortoil from '../assets/FORTEUPSTREAM.jpg'

const partnerData = [
    { id: 1, image: Shell },
    { id: 2, image: Chevron },
    { id: 3, image: Exxon },
    { id: 4, image: Total },
    { id: 5, image: BP },
    { id: 6, image: Petrobras },
    {id: 7, image: Fortoil}
];

export default partnerData;